import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
const NotFound: React.FC = () => {
  usePageTitle('Page not found');
  const { pathname } = useLocation();
  return <section><h1>Page not found</h1><p>The page you requested could not be found.</p><Link to={pathname.startsWith('/portal/') ? '/portal' : pathname.startsWith('/admin/') ? '/admin' : '/'}>Go home</Link></section>;
};
export default NotFound;
